var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#08c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.1 8.4c-.1.2-.1.4 0 .6l4.3 7.6V8.2H7.6c-.2 0-.4 0-.5.2zM16.4 8.2h-3.8v8.4L16.9 9c.1-.2.1-.4 0-.5-.1-.3-.2-.3-.5-.3z",
    fill: "#daa635",
    opacity: 1,
    "data-original": "#0088cc",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm6 8.6L12.7 19c-.2.3-.4.4-.7.4s-.6-.2-.7-.4L6 9.6c-.4-.6-.4-1.3 0-1.8.3-.6.9-.9 1.6-.9h8.9c.7 0 1.3.3 1.6.9.2.3.2.6.2.9s-.1.6-.3.9z",
    fill: "#daa635",
    opacity: 1,
    "data-original": "#0088cc",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTon);
export default __webpack_public_path__ + "static/media/ton.208e7ca14dc2059b1f150d93d4632071.svg";
export { ForwardRef as ReactComponent };